import { ContentWrapper } from '../ContentWrapper';
import { formatDate } from './util/formatDate';
import { getStatusIcon } from './util/getStatusIcon';

export const DEFAULT_COMMENT = 'No Summary Documented';

export const LatestReviewSummaryPopover = ({
  review,
  title,
  patientDetails,
  patientInfo,
  withStatusIndicator = false,
}) => {
  const getFormattedDate = () => {
    if (!review) return '';

    if (review.entity_id?.length > 4) {
      return review.last_update || review.creation_date;
    }

    return formatDate(review.modified_date, review.creation_date);
  };

  const handleQuickLinkClick = (event) => {
    event.preventDefault();
    patientDetails(patientInfo);
  };

  if (!review) return null;

  return (
    <ContentWrapper
      title={title}
      handleLinkClick={handleQuickLinkClick}
      linkText='Go to Reviews'
    >
      {/* Status and Date Block */}
      <div className='date-status font-bold'>
        {getFormattedDate()}
        {getStatusIcon(review.review_status)}
      </div>
      {withStatusIndicator && review.status_indicator && (
        <p className='font-bold status-indicator'>{review.status_indicator}</p>
      )}

      {/* Comment Block */}
      <p className='comment'>{review.review_comment || DEFAULT_COMMENT}</p>
    </ContentWrapper>
  );
};
